(() => {
  'use strict';
  const queryFor = value => {
    const words = value.replace(/tag:generics/gi, '').replace(/\bAND\b/g, '').replace(/[^\p{L}\p{N}\s-]/gu, ' ').trim().split(/\s+/).filter(Boolean).slice(0,12);
    return 'tag:generics' + (words.length ? ' AND ' + words.map(word => word + '*').join(' ') : '');
  };
  const withPreview = url => {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  class GenericSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[type=search]');
      this.panel = this.querySelector('.sc-search-dropdown');
      this.list = this.querySelector('[role=listbox]');
      this.status = this.querySelector('[role=status]');
      this.all = this.querySelector('.sc-search-all');
      this.index = -1;
      this.revision = 0;
      if (this.closest('.sc-search-page')) this.input.value = (new URLSearchParams(location.search).get('q') || '').replace(/tag:generics/gi,'').replace(/\bAND\b/g,'').replace(/\*/g,'').trim();
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const active = this.list.children[this.index];
        if (!this.panel.hidden && active) location.assign(active.href);
        else location.assign(this.url(false).href);
      });
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer); this.controller?.abort(); this.revision++;
        this.index = -1; this.list.replaceChildren(); this.input.removeAttribute('aria-activedescendant');
        if (!this.input.value.trim()) return this.close();
        this.status.textContent = this.dataset.loading;
        this.all.href = this.url(false).href;
        this.open();
        this.timer = setTimeout(() => this.search(),250);
      });
      this.input.addEventListener('focus', () => { if (this.input.value.trim() && this.list.childElementCount) this.open(); });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.close(); return; }
        if (!['ArrowDown','ArrowUp'].includes(event.key) || !this.list.childElementCount) return;
        event.preventDefault(); this.open();
        this.index = (this.index + (event.key === 'ArrowDown' ? 1 : -1) + this.list.childElementCount) % this.list.childElementCount;
        [...this.list.children].forEach((item,index)=>item.setAttribute('aria-selected',String(index===this.index)));
        const active=this.list.children[this.index];this.input.setAttribute('aria-activedescendant',active.id);active.scrollIntoView({block:'nearest'});
      });
      this.addEventListener('focusout', () => requestAnimationFrame(()=>{ if (!this.contains(document.activeElement)) this.close(); }));
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      document.addEventListener('pointerdown',this.outside);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();document.removeEventListener('pointerdown',this.outside);}
    url(section) {
      const url = withPreview(new URL(this.dataset.searchUrl,location.origin));
      url.searchParams.set('q',queryFor(this.input.value));url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');
      if(section)url.searchParams.set('section_id','sc-generic-search-results');else url.searchParams.set('view','generics');
      return url;
    }
    open(){this.panel.hidden=false;this.input.setAttribute('aria-expanded','true');}
    close(){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.index=-1;}
    async search() {
      const revision=this.revision;this.controller=new AbortController();
      try {
        const response=await fetch(this.url(true),{signal:this.controller.signal});if(!response.ok)throw Error('search');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        if(revision!==this.revision)return;
        const container=doc.querySelector('[data-sc-search-results]');if(!container)throw Error('results');
        const rows=[...container.querySelectorAll('[data-sc-search-result]')].slice(0,8);
        this.list.replaceChildren(...rows.map((row,index)=>{
          row.id=this.list.id+'-'+index;row.setAttribute('role','option');row.setAttribute('aria-selected','false');row.href=withPreview(new URL(row.getAttribute('href'),location.origin)).href;
          row.querySelectorAll('img').forEach(img=>img.loading='eager');return row;
        }));
        this.status.textContent=rows.length?'':this.dataset.empty;
      }catch(error){if(error.name!=='AbortError'&&revision===this.revision)this.status.textContent=this.dataset.error;}
    }
  }
  class DesignHelp extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.trigger=this.querySelector('.sc-help-trigger');this.panel=this.querySelector('dialog');
      this.trigger.addEventListener('click',()=>{this.panel.show();this.trigger.setAttribute('aria-expanded','true');this.openChat();});
      const close=()=>{this.panel.close();this.trigger.setAttribute('aria-expanded','false');this.trigger.focus();};
      this.querySelector('.sc-help-close').addEventListener('click',close);
      this.panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close();}});
      this.querySelector('.sc-chat-reopen').addEventListener('click',()=>this.openChat());
      const link=this.querySelector('[data-sc-quote-link]');link.href=withPreview(new URL(link.href)).href;
    }
    async openChat(){
      this.querySelector('[data-sc-chat-status]').textContent='';
      const started=Date.now();
      clearInterval(this.chatTimer);
      const open=()=>{
        const chat=document.querySelector('shopify-chat');
        const button=chat?.shadowRoot?.querySelector('button[part=activator]');
        if(button){if(button.getAttribute('aria-expanded')!=='true')button.click();clearInterval(this.chatTimer);return true;}
        if(Date.now()-started>8000){const status=this.querySelector('[data-sc-chat-status]');status.textContent=status.dataset.unavailable;clearInterval(this.chatTimer);}
        return false;
      };
      if(!open())this.chatTimer=setInterval(open,300);
    }
    disconnectedCallback(){clearInterval(this.chatTimer);}
  }
  class QuoteDesign extends HTMLElement {
    async connectedCallback(){
      if(this.ready)return;this.ready=true;
      const handle=new URLSearchParams(location.search).get('generic_design');
      if(!handle||! /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle))return;
      this.hidden=false;const status=this.querySelector('[data-sc-quote-status]');
      try {
        const url=withPreview(new URL(this.dataset.productsUrl+encodeURIComponent(handle),location.origin));url.searchParams.set('section_id','sc-quote-design');
        const response=await fetch(url);if(!response.ok)throw Error('product');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const content=doc.querySelector('[data-sc-quote-content]');if(!content)throw Error('design');
        const title=content.dataset.title;this.querySelector('[data-sc-quote-slot]').replaceChildren(content);
        this.reference='GENERIC MOULD: '+title;
        const reference=document.createElement('p');reference.className='sc-quote-reference';reference.textContent=this.reference;content.append(reference);
        const viewer=content.querySelector('model-viewer');
        if(viewer){let canRender=false;try{const canvas=document.createElement('canvas');const gl=canvas.getContext('webgl2')||canvas.getContext('webgl');canRender=Boolean(gl);gl?.getExtension('WEBGL_lose_context')?.loseContext();}catch(error){canRender=false;}if(!canRender)viewer.style.visibility='hidden';const red=()=>{const poster=content.querySelector('.sc-quote-poster');if(poster&&canRender&&viewer.model?.materials.length)poster.hidden=true;viewer.model?.materials.forEach(material=>{material.setAlphaMode('OPAQUE');material.pbrMetallicRoughness.setBaseColorFactor('#d91f32');material.pbrMetallicRoughness.setMetallicFactor(0);material.pbrMetallicRoughness.setRoughnessFactor(.55);});};viewer.addEventListener('load',red);customElements.whenDefined('model-viewer').then(()=>{if(viewer.loaded)red();});}
        this.prefill(status);
      }catch(error){status.textContent=this.dataset.error;}
    }
    prefill(status){
      let attempts=0;
      const fill=()=>{
        const field=document.querySelector('.acerill-custom-form textarea[name="f36c7b96-a57c-4ff4-9600-e3b1bb2c9667"]') || document.querySelector('.acerill-custom-form textarea[placeholder="Anything else to tell us about your custom silicone mould idea?"]');
        if(!field)return false;
        if(field.dataset.scPrefilled==='true'||field.value.includes(this.reference))return true;
        // Use the native setter so React's controlled textarea receives the change.
        const setter=Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set;
        const notes=field.value.replace(/^GENERIC MOULD:.*(?:\r?\n){0,2}/,'');
        setter.call(field,this.reference+'\n\n'+notes);field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));field.dataset.scPrefilled='true';
        return true;
      };
      // The app loads asynchronously; stop once filled and never overwrite later edits.
      this.fillTimer=setInterval(()=>{
        attempts++;
        if(fill()){clearInterval(this.fillTimer);return;}
        if(attempts>=120){clearInterval(this.fillTimer);status.textContent=this.dataset.prefillError;}
      },250);
    }
    disconnectedCallback(){clearInterval(this.fillTimer);}
  }
  if(!customElements.get('sc-generic-search'))customElements.define('sc-generic-search',GenericSearch);
  if(!customElements.get('sc-design-help'))customElements.define('sc-design-help',DesignHelp);
  if(!customElements.get('sc-quote-design'))customElements.define('sc-quote-design',QuoteDesign);
})();
